import styled from 'styled-components';
import { Link } from 'gatsby';

const StyledLink = styled(Link)``;

export default StyledLink;
